import { Button } from "react-bootstrap";
import "@/styles/components/gitcha-not-available-modal.css";
import Modal from "react-bootstrap/Modal";

const MatchesFeatureModal = (props) => {
  const { show, onHide } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-wrapper"
      backdrop="static"
    >
      <Modal.Body className="modal-body">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        />

        <div className="content-container">
          <h3 className="content-title-text">
            Property Matching is a Buyer Listing Service feature.
          </h3>
          <p className="fs-6 content-description-text mt-3">
            When your MLS or association launches the BLS, you and every agent in your market
            get access to cross pollinated matching, real-time demand
            intelligence, and more.
          </p>
          <p className="fs-6 content-description-text mt-3">
            Ask your MLS or association about The Buyer Listing Service to unlock this for your
            membership.
          </p>
          <p className="fs-6 content-description-text mt-3">
            <a
              href="https://thebuyerlistingservice.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              thebuyerlistingservice.com
            </a>
          </p>
        </div>

        <div className="modal-footer mt-20 p-0 d-flex justify-content-end">
          <Button variant="primary" onClick={onHide}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MatchesFeatureModal;
